import React, { FunctionComponent, useEffect } from 'react';
import { useRouteMatch } from 'react-router';
import { Radio } from 'antd';
import routes from '@config/routes';
import componentContent from './PromotionSelector.content.json';
import useTranslate from '@hooks/useTranslate';
import { RadioChangeEvent } from 'antd/lib/radio';
import { goTo } from '@helpers/navigation';

const { promotionActivity, promotionGames } = routes;
const promotionRoutes = [promotionActivity, promotionGames];

interface PromotionSelectorProps {}

const PromotionSelector: FunctionComponent<PromotionSelectorProps> = () => {
  const match = useRouteMatch();
  const currentRoute = promotionRoutes.find((route) => route.path === match.path);
  const content = useTranslate(componentContent);
  const onChange = ({ target }: RadioChangeEvent) => goTo(target.value);

  return (
    <>
      <Radio.Group
        style={{ marginBottom: 16 }}
        onChange={onChange}
        value={currentRoute ? currentRoute.name : undefined}
      >
        {promotionRoutes.map((route) => (
          <Radio.Button
            key={route.name}
            value={route.name}
          >
            {content[route.name]}
          </Radio.Button>
        ))}
      </Radio.Group>
    </>
  );
};

export default PromotionSelector;
